// src/hooks/paxTypes/useGetPaxTypes.js
import { useQuery } from "@tanstack/react-query";
import { getAllPaxTypes } from "../../api/apiPaxTypes";

const QUERY_KEY = ["paxTypes"];

const useGetPaxTypes = (page = 1, perPage = 15, filters = {}) => {
  const {
    data,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: [...QUERY_KEY, page, perPage, filters],
    queryFn: () => getAllPaxTypes(page, perPage, filters),
    keepPreviousData: true,
  });

  return {
    isLoading,
    error: isError ? error : null,
    paxTypes: data?.data || data?.paxTypes || [],
    meta: data?.data?.meta || null,
  };
};

export default useGetPaxTypes;